import useBasket from 'api/baskets/useBasket/useBasket';
import useDeleteBasket from 'api/baskets/useDeleteBasket/useDeleteBasket';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import BasketEditModal from 'components/shared/Modals/basket/BasketEditModal/BasketEditModal';
import BasketInsertModal from 'components/shared/Modals/basket/BasketInsertModal/BasketInsertModal';
import BasketPrintModal from 'components/shared/Modals/basket/BasketPrintModal/BasketPrintModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useTableBasketColumns from 'hooks/basket/useTableBasketColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const Baskets = () => {
  const { guid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getBasketList, loading, basketList, pageRef] = useBasket(guid);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenBasket, setEditChosenBasket] = useState({});
  const [chosenPrintBasket, setChosenPrintBasket] = useState({});
  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);

  const navigate = useNavigate();
  const [deleteRequest] = useDeleteBasket();
  const { can } = usePermissions();

  const basketPermissions =
    permissions.general.categories.warehouseManagement.locationManagement
      .locations.areas.baskets;

  const canCreate = can(basketPermissions.create);
  const canDelete = can(basketPermissions.delete);
  const canEdit = can(basketPermissions.edit);
  const canPrint = can(basketPermissions.print);

  const tableRef = useRef(null);

  useEffect(() => {
    getBasketList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getBasketList({ page, count: pageSize });
  }, [pageSize]);

  const printBasket = useCallback(
    row => () => {
      setChosenPrintBasket(row);
      setIsPrintModalOpen(true);
    },
    [],
  );

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenBasket(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = useTableBasketColumns(
    printBasket,
    deleteItem,
    editItem,
    tableRef,
    {
      canPrint,
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(id, getBasketList, setIsDeleteModalOpen, setDeleteLoading);
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getBasketList({ page: pageNumber, count: pageSize, term: lastSearch });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getBasketList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(basketList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={basketList[page]}
          rows={basketList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'افزودن سبد' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <BasketEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenBasket={editChosenBasket}
          getBasketList={getBasketList}
        />
      ) : null}

      {canCreate ? (
        <BasketInsertModal
          open={isInsertModalOpen}
          getBasketList={getBasketList}
          guid={guid}
          handleClose={() => setIsInsertModalOpen(false)}
          onUpdateList={() =>
            getBasketList({ page, count: pageSize, term: lastSearch })
          }
        />
      ) : null}

      {canPrint ? (
        <BasketPrintModal
          open={isPrintModalOpen}
          handleClose={() => setIsPrintModalOpen(false)}
          chosenPrintBasket={chosenPrintBasket}
        />
      ) : null}
    </>
  );
};

export default Baskets;
